export default __webpack_public_path__ + "static/media/phone.62ab61ff.png";